'use strict';
(function() {
    $(document).ready(function() {

        lightbox.option({
            positionFromTop: $(window).height()/2,
            wrapAround: true
        });

        setTimeout(() => {
          const $demoSlider =  $('.flexslider-full');
          $demoSlider.flexslider({
              animation: "slide",
              animationLoop: true,
              slideshow: true,
              keyboard: false,
              //itemWidth: 200,
              itemMargin: 5,
              prevText: "",
              nextText: ""
          });
        }, 100);

        setTimeout(() => {
            const $demoSlider =  $('.flexslider');
            $demoSlider.flexslider({
                animation: "slide",
                animationLoop: true,
                slideshow: true,
                keyboard: false,
                itemWidth: 200,
                itemMargin: 5,
                prevText: "",
                nextText: ""
            });
        }, 100);

        setTimeout(() => {
            AOS.init();
        }, 2000);

        $('#section-faq .faq .topic').click(function(){
            $(this).parent().toggleClass('active');
            if (window.fbq) fbq('trackCustom', 'BBFAQ_Click', { text: $(this).text()});
        });
    });
})();

function playVideo() {
    $.fancybox({
			'autoScale'		: false,
			'transitionIn'	: 'none',
			'transitionOut'	: 'none',
			'title'			: "",
			'width'			: "1920",
            "height"        : "1155",
            "padding"       : "0",
            "aspectRatio"   : true,
			'href'			: "https://www.youtube.com/embed/AaHNwr75O3w?autoplay=1&fs=1&rel=0",
			'type'			: 'iframe'
		});

}

function playVideoEn() {
    $.fancybox({
			'autoScale'		: false,
			'transitionIn'	: 'none',
			'transitionOut'	: 'none',
			'title'			: "",
			'width'			: "1920",
            "height"        : "1155",
            "padding"       : "0",
            "aspectRatio"   : true,
			'href'			: "https://www.youtube.com/embed/kZO_qvOYSF4?autoplay=1&fs=1&rel=0",
			'type'			: 'iframe'
		});

}

// var countDownTimer = 0;
function preorderTimer() {
    countDownTimer++;
    var targetDate = new Date("2019/04/23 10:00 UTC+8");
    var timestamp = Math.floor(targetDate / 1000);
    var diff = timestamp - window['PHP_TIMESTAMP'] - countDownTimer;
    var min = Math.floor(diff / 60);
    var sec = Math.floor(diff % 60);
    min = min < 10 ? '0' + min : min;
    sec = sec < 10 ? '0' + sec : sec;
    if (diff < 0) {
        location.reload();
    }
    $('.btn.preorder a').text('預購即將開始 ' + min + ' 分 ' + sec + ' 秒');
    $('.btn.buy-now a').text('預購即將開始 ' + min + ' 分 ' + sec + ' 秒');
}
// var mm = window.setInterval("preorderTimer()", 1000);
// (function(){
//     const form = $('#beambox-email-collector-form');
//     $(document).ready(()=>{
//         form.submit(onSendHandler);
//     });

//     function onSendHandler(event){
//         event.preventDefault();
//         sendMail(event);
//     }

//     function sendMail(event){
//         event.preventDefault();
//         const submitBtn = form.find('input[type=submit]');
//         submitBtn.css('cursor', 'wait');
//         $.post(
//             _PHP.ajax_url, //send to /admin-ajax.php
//             {
//                 'action': 'collect_beambox_email',
//                 'email': event.target.email.value
//             },
//             function (response) {
//                 if (response.status === "ok") {
//                     onSendSuccess();
//                 } else {
//                     var error = response.error || "unknown error";
//                     alert("Subscription Fail: " + JSON.stringify(error));
//                 }
//                 submitBtn.css('cursor', 'pointer');
//             }
//         );
//     }

//     function onSendSuccess(){
//         alert("Please check your email to confirm subscription.");
//     }


// })();
// (function countDownBanner($){
//     $(document).ready(() => {
//         const bannerID = 'countDownBanner';
//         if (!document.getElementById(bannerID)) {
//             return;
//         }

//             // Set the date we're counting down to
//         var countDownDate = new Date("Jan 31, 2018 23:59:59").getTime();

//         // Update the count down every 1 second
//         var x = setInterval(function() {

//         // Get todays date and time
//         var now = new Date().getTime();

//         // Find the distance between now an the count down date
//         var distance = countDownDate - now;

//         // Time calculations for days, hours, minutes and seconds
//         var days = Math.floor(distance / (1000 * 60 * 60 * 24));
//         var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2,0);
//         var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2,0);
//         var seconds = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2,0);

//         // Display the result in the element with id="demo"
//         document.getElementById(bannerID).innerHTML = `優惠倒數 ${hours} 時 ${minutes} 分 ${seconds} 秒`;

//         // If the count down is finished, write some text
//         if (distance < 0) {
//             clearInterval(x);
//             document.getElementById(bannerID).innerHTML = 'EXPIRED';
//         }
//         }, 1000);
//     });
// })(jQuery);
